// 시안 F Nextcloud 피부(#2014 f-collab · 구조는 원제품 · 색·크기만). EmbedPage·CollabViewPage 가 NC iframe 문서에 넣는다.
// 공통(모든 NC 화면: 드라이브·캘린더·화상회의·NC 메일·협업 도구 5종) + 드라이브 전용 두 덩어리.
// 왜 CSS 주입인가: 남색은 서버 테마 사본(nc-patches/theme-ourbox/core/css/server.css:23-40)이 body id 4개에 !important 로
//    칠한다 — 같은 오리진 iframe 이라 통제 지점은 그 문서의 style 요소다(collabSkinMm 선례). 서버 사본은 건드리지 않는다.
// 🔴 원제품 부품 CSS 는 scoped(`.button-vue[data-v-…]` 속성 선택자) — 클래스 하나짜리 규칙은 뒤에 붙어도 진다.
//    부품 규칙은 `#body-user ` 를 앞에 붙이고, 높이는 부품 변수(--button-size)로 바꾼다.
// 🔴 NC 는 바탕 밝기로 글자색을 계산한다 → --color-background-plain-text 도 덮고 body id 4개 전부에 건다.
// 🔴 서버 테마 남색도 body id + !important 라 특이성이 같으면 «나중 것»이 이긴다 — 우리 style 은 로드 중(50ms 폴링)에
//    들어가므로 그 뒤에 파싱된 테마 <link> 가 이길 수 있다(10-27 DEV 390 /calendar: 라벨만 어둡고 바탕·종은 남색·흰색).
//    → 바탕 규칙은 `html ` 을 앞에 붙여 특이성으로 이기고(순서·화면 폭과 무관), 머리는 #header 에 바탕·변수를 직접 건다.
// 🔴 다크 OS 에서는 끈다(NC 가 prefers-color-scheme 다크 변수를 따로 붙인다) — 색·글자 규칙은 전부 밝은 조건 안이다.
//    단 드라이브 내비 배치(폭·접힘 여백)는 예외 — 색이 아니라서 다크 OS 에서도 같은 폭이어야 한다(밝은 조건 밖).
//    머리 글자는 인라인 상수가 아니라 --gw-nc-hdr-* 변수를 읽어 피부와 함께 꺼진다(꺼지면 var() 기본값 = 옛 흰색).
// 🔴 드라이브 전용(내비 폭 180 등)은 파일 앱 문서(#content.app-files · #content-vue.app-files)에만 — 화상회의 대화 목록·
//    캘린더 왼쪽 칸·협업 도구 5종도 같은 NC 내비 부품을 써서 공통에 넣으면 거기로 샌다.
// 🔴 CSS 문자열 안에 /* */ 주석을 넣지 않는다(collabSkinMm 과 같은 규약 — 시험 해석기가 주석을 셀렉터로 읽는다).
// 선택자는 NC 34.0.5 · @nextcloud/vue 9.13.1 기준 — 판 올림 때 클래스가 바뀌면 조용히 빠진다.
export const NC_FSKIN_STYLE_ID = 'gw-nc-fskin';
export const NC_FSKIN_DRIVE_STYLE_ID = 'gw-nc-fskin-drive';
export const NC_FSKIN_LIGHT_MEDIA = '@media not all and (prefers-color-scheme: dark)';
export const NC_BODY_IDS = ['#body-user', '#body-settings', '#body-login', '#body-public'];
// 바탕 규칙 선택자 — 특이성 (1,0,1) 이 서버 테마 `#body-*`(1,0,0) 보다 높아 style 순서와 상관없이 이긴다.
export const NC_BODY_SELECTORS = NC_BODY_IDS.map((id) => 'html ' + id);
// 머리 줄이 있는 body — 로그인·공개 공유 화면엔 게이트웨이 머리 정리가 없다.
export const NC_HEADER_SELECTORS = ['#body-user #header', '#body-settings #header'];

// 공통 — 바탕·머리(g2-011 머리 줄) · 주 단추(g2-010). 값은 시안 F 줄 10(토큰)·12(단추 .btn)·20(협업 화면).
export const NC_FSKIN_COMMON_CSS = [
  NC_FSKIN_LIGHT_MEDIA + '{',
  NC_BODY_SELECTORS.join(',') + '{'
    + 'background-color:#ffffff !important;'
    + '--color-background-plain:#ffffff !important;'
    + '--color-background-plain-text:#32312e !important;'
    + '--background-image-invert-if-bright:invert(100%) !important;'   // 흰 바탕에서 로고가 묻히지 않게
    + '--border-radius-element:5px !important;'
    + '--border-radius-large:5px !important;'                          // :root 에서 element 로 계산돼 내려온 값도 같이
    + '--default-font-size:13px !important;'
    + '--gw-nc-hdr-fg:#32312e;--gw-nc-hdr-hover:#efefed;--gw-nc-hdr-line:#e5e5e2'
    + '}',
  // 머리 줄(g2-011) — 바탕을 #header 에 직접 칠하고, 머리 안 글자·아이콘이 읽는 변수도 #header 에 건다
  // (종 = NcHeaderMenu 트리거가 --color-background-plain-text 를 읽는다). body 쪽 승패와 상관없이 흰 머리·어두운 글자다.
  NC_HEADER_SELECTORS.join(',') + '{background-color:#ffffff !important;border-bottom:1px solid #eeeeec;'
    + '--color-background-plain:#ffffff !important;--color-background-plain-text:#32312e !important;'
    + '--background-image-invert-if-bright:invert(100%) !important}',
  // 주 단추(g2-010) — 높이는 부품 변수로 · 9.x 클래스는 --primary(8.x 의 --vue-primary 는 쓰지 않는다)
  '#body-user .button-vue--primary{--button-size:31px;--button-padding:11px;border-bottom-width:0 !important;'
    + 'font-size:13px;font-weight:500;box-shadow:0 1px 1px #eeeeec}',
  '}',
].join('');

// 드라이브 왼쪽 내비 칸 폭(px) — 라벨이 짧다(모든 파일·아워박스·삭제된 파일 · 12px · 좌우 패딩 11). 조정은 이 한 줄만.
export const NC_DRIVE_NAV_W = 180;

// 드라이브 전용 — cleanupDriveHeader 에서만 · 파일 앱 문서에만.
// 내비 칸 = `.app-navigation` — 대역(모양 A)은 #app-navigation-vue 자신, @nextcloud/vue NcAppNavigation(모양 B)은
// 바깥 div.app-navigation 안에 nav#app-navigation-vue.app-navigation__content 다. 폭은 칸에 건다(안쪽만 줄이면 칸은 300 그대로).
export const NC_FSKIN_DRIVE_CSS = [
  // 배치(g2-024) — 밝기 조건 밖 · 배치 속성만. 접힘 여백도 폭과 짝(NC 는 -300px 고정이라 폭만 바꾸면 접을 때 본문 왼쪽이
  // 잘린다) · 접힘 클래스는 --close(8.x)·--closed 둘 다 받는다. 안쪽 nav 는 칸을 넘지 않게(모양 A 에선 매칭 없음).
  '#body-user .app-navigation{width:' + NC_DRIVE_NAV_W + 'px !important;max-width:' + NC_DRIVE_NAV_W + 'px !important;'
    + 'min-width:0 !important;box-sizing:border-box}',
  '#body-user .app-navigation.app-navigation--close,#body-user .app-navigation.app-navigation--closed'
    + '{margin-inline-start:-' + NC_DRIVE_NAV_W + 'px !important}',
  '#body-user .app-navigation #app-navigation-vue{width:auto !important;max-width:100% !important;box-sizing:border-box}',
  NC_FSKIN_LIGHT_MEDIA + '{',
  // 내비 색·여백(g2-024) — 바탕·오른쪽 줄은 칸에, 안쪽 여백은 #app-navigation-vue 에
  '#body-user .app-navigation{background:#fbfbfa;border-right:1px solid #eeeeec}',
  '#body-user #app-navigation-vue{padding:19px 11px}',
  '#body-user #app-navigation-vue .app-navigation-entry{min-height:34px;border-radius:5px}',
  '#body-user #app-navigation-vue .app-navigation-entry__name{font-size:12px;font-weight:550}',
  '#body-user #app-navigation-vue .app-navigation-entry.active{background:#eaeae7 !important}',
  // 검색(g2-012) — 시안 줄 14(.search-box h30 · 12px)
  '#body-user #app-navigation-vue .input-field{margin-bottom:21px}',
  '#body-user #app-navigation-vue .input-field__input{height:30px !important;font-size:12px;'
    + 'box-shadow:none !important;border:1px solid #e5e5e2 !important}',
  // 제목(g2-025) — 맨 끝 경로 조각
  '#body-user .files-list__breadcrumbs .vue-crumb:last-child,'
    + '#body-user .files-list__breadcrumbs .vue-crumb:last-child .button-vue__text'
    + '{font-size:25px !important;font-weight:680 !important;letter-spacing:-.7px}',
  '#body-user .files-list__breadcrumbs .vue-crumb:last-child{height:auto !important}',
  // 보기 전환(g2-026)
  '#body-user .files-list__header-grid-button{--button-size:24px;border-radius:5px;background:#f1f1ef !important}',
  // 표(g2-027) — 행 높이는 가상 목록 JS 상수 44(VirtualList.vue:166)라 손대지 않는다
  '#body-user .files-list th,#body-user .files-list__thead th'
    + '{font-size:12px !important;font-weight:400 !important;color:#92918d !important}',
  '#body-user .files-list tr.files-list__row,#body-user .files-list td{border-bottom-color:#eeeeec !important}',
  '#body-user .files-list .files-list__row-name-text{font-size:12px !important;color:#32312e !important}',
  '#body-user .files-list .files-list__row-mtime,#body-user .files-list .files-list__row-size'
    + '{font-size:12px !important;color:#64635f !important}',
  '#body-user .files-list__tfoot td{font-size:11px !important;color:#92918d !important}',
  // 빈 화면(g2-029) — 표 밖 NcEmptyContent
  '#body-user .files-list__empty-view-wrapper .empty-content__name,'
    + '#body-user [data-cy-files-content-empty] .empty-content__name'
    + '{font-size:12px !important;font-weight:400 !important;color:#92918d !important}',
  // 390(g2-028)
  '@media (max-width:600px){',
  '#body-user .files-list__breadcrumbs .vue-crumb:last-child,'
    + '#body-user .files-list__breadcrumbs .vue-crumb:last-child .button-vue__text{font-size:24px !important}',
  '}',
  '}',
].join('');

// style 을 head 에 '1개만' 유지한다 — 폴링(50ms·70ms)+onLoad 에서 반복 호출되므로 멱등이 필수.
// 이미 있으면 새로 만들지 않고 내용이 달라졌을 때만 갱신한다(applyMmFSkin 과 같은 모양).
function upsertStyle(doc, id, css) {
  const found = doc.getElementById(id);
  if (found) {
    if (found.textContent !== css) found.textContent = css;
    return;
  }
  const st = doc.createElement('style');
  st.id = id;
  st.textContent = css;
  doc.head.appendChild(st);
}

function removeStyle(doc, id) {
  const found = doc.getElementById(id);
  if (found && found.parentNode) found.parentNode.removeChild(found);
}

// NC 파일 앱 문서인가 — NC 레이아웃은 앱 본문을 #content.app-<appid> 로 그리고, Vue 앱(NcContent)이 거기 붙으면
// 그 자리가 #content-vue.content.app-<appid> 로 바뀐다 → 둘 다 본다(캘린더·화상회의는 app-calendar·app-spreed 라 거짓).
export function isNcFilesDocument(doc) {
  try {
    return !!(doc && doc.querySelector && doc.querySelector('#content.app-files, #content-vue.app-files'));
  } catch (e) { return false; }
}

// 공통은 늘 넣는다 · drive 가 참이고 그 문서가 파일 앱(#content.app-files · #content-vue.app-files)이면 드라이브 전용도 넣는다.
// 그 밖에는 드라이브 전용을 넣지 않고, 이미 있으면 뗀다(드라이브 iframe 안에서 다른 NC 앱으로 넘어간 경우).
// doc·head 가 없으면(로드 중 문서) 조용히 no-op.
export function applyNcFSkin(doc, { drive = false } = {}) {
  if (!doc || !doc.head) return;
  upsertStyle(doc, NC_FSKIN_STYLE_ID, NC_FSKIN_COMMON_CSS);
  if (drive && isNcFilesDocument(doc)) upsertStyle(doc, NC_FSKIN_DRIVE_STYLE_ID, NC_FSKIN_DRIVE_CSS);
  else removeStyle(doc, NC_FSKIN_DRIVE_STYLE_ID);
}
